import template from './notas-credito.html';
import abrirTemplate from '../../cajas/list/abrir.html';
import { FormActions } from 'core/services/form';
import notasCreditoI18N from 'i18n/notas-credito/es.json';
import config from 'config.json';
import { rest } from 'core/api';
import { download } from '../../../core/util';
import { formatErrorMessage } from 'core/util';

export let NotasCreditoComponent = {
  templateUrl: template,
  selector: 'notasCredito',
  bindings: {
    translations: '='
  },
  controller: NotasCreditoCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(notasCreditoI18N).concat(commonsI18N);

NotasCreditoCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'CustomModal', 'localStorageService', '$resource', 'HeadersUtil'
];

function NotasCreditoCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, CustomModal, localStorageService, $resource, HeadersUtil) {

  var defaultColumnOrder = ['numeroTimbrado', 'numeroComprobante', 'factura.numeroComprobante', 'cliente.razonSocial', 'fecha', 'estado.value'];
  var staticFilter = Filter.path('activo').eq(true);
  BasicFactory.setup('notas-credito');

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_nota_credito');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));
  this.localModel = {};
  this.$state = $state;

  this.options = {
    staticFilter,
    resource: 'notas-credito',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de notas de credito'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'numeroTimbrado', title: this.translations['Número Timbrado'] },
      { data: 'factura.numeroComprobante', title: this.translations['Número Factura'] },
      { data: 'numeroComprobante', title: this.translations['Número Comprobante'] },
      { data: 'cliente.razonSocial', title: this.translations['Cliente'] },
      { data: 'fechaNotaCredito', title: this.translations['Fecha'], type: 'date-range' },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onView: onView.bind(this),
    canEditCondition: canEditCondition.bind(this),
    canRemoveCondition: canRemoveCondition.bind(this),
    canAnular: canAnular.bind(this),
    canAplicar: canAplicar.bind(this),
    canImprimirComprobante: canImprimirComprobante.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Anular'] + '" ng-show="options.canAnular(rowsData[<%= dataId %>])" ng-click="anularNotaCredito(<%= dataId %>)"> <span class="glyph-icon icon-close" style="top: -8px;"></span></button>',
        functionName: 'anularNotaCredito',
        functionDef: (itemId) => {
          let self = this;
          CustomModal.open({
            title: 'Anular Nota de Crédito',
            id: itemId,
            message: '¿Desea anular la Nota de Crédito?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.anularNotaCredito({ id: itemId }, {
                body: JSON.stringify({})
              }, (err, data) => {
                if (!err && data.estado.value == 'Anulada') {
                  ngNotify.set(self.translations['Anulada Correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Aplicar'] + '" ng-show="options.canAplicar(rowsData[<%= dataId %>])" ng-click="aplicarNotaCredito(<%= dataId %>)"> <span class="glyph-icon icon-check" style="top: -8px;"></span></button>',
        functionName: 'aplicarNotaCredito',
        functionDef: (itemId) => {
          let self = this;
          CustomModal.open({
            title: 'Aplicar Nota de Crédito',
            id: itemId,
            message: '¿Desea aplicar la Nota de Crédito?',
            ok: function() {
              let caja = localStorageService.get('caja');
              if (!caja) {
                ngNotify.set(self.translations['Debe asignar una caja al equipo'], 'warn');
                return;
              } else if (!caja.sesionActual || caja.sesionActual.estado.value !== 'Abierta') {
                self.abrirCaja('nc', itemId);
              } else {
                $ngRedux.dispatch(rest.actions.aplicarNotaCredito({ id: itemId }, {
                  body: JSON.stringify({})
                }, (err, data) => {
                  if (!err && data.estado.value == 'Aplicada') {
                    ngNotify.set(self.translations['Aplicada Correctamente'], 'success');
                    self.options.reloadData();
                  } else if (err) {
                    ngNotify.set(err.message, 'warn');
                  }
                }));
              }
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Imprimir Comprobante'] + '" ng-show="options.canImprimirComprobante(rowsData[<%= dataId %>])" ng-click="imprimirComprobante(<%= dataId %>, rowsData)"> <span class="glyph-icon icon-file-pdf-o" style="top: -8px;"></span></button>',
        functionName: 'imprimirComprobante',
        functionDef: (itemId, rowsData) => {
          const tipoImpresionComprobante = rowsData[itemId] && rowsData[itemId].claseTimbrado;
          if (tipoImpresionComprobante === 'preimpreso') {
            this.imprimirPreimpreso([itemId]);
          } else if (tipoImpresionComprobante === 'autoimpreso') {
            this.imprimirAutoimpreso([itemId]);
          } else {
            ngNotify.set(`Tipo de comprobante no definido (Autoimpreso o Preimpreso)`, 'warn');
          }
        }
      }
    ]
  };

  this.imprimirPreimpreso = imprimirPreimpreso.bind(this);
  function imprimirPreimpreso(facturasPersistidasIds) {
    // Imprimir todas las facturas creadas
    const sortedFacturasPersistidasIds = facturasPersistidasIds.sort((a, b) => a - b);
    sortedFacturasPersistidasIds.reduce((downloadsPromiseChain, id) => {
      return downloadsPromiseChain.then(() => {
         return download('notas-credito', id, 'imprimir-comprobante', config, $resource, HeadersUtil, null, null, true);
      });
    }, Promise.resolve());
  }

  this.imprimirAutoimpreso = imprimirAutoimpreso.bind(this);
  function imprimirAutoimpreso(facturasPersistidasIds) {
    const self = this;
    // Si esta configurada la URL para imprimir autoimpresor
    if (this.urlAutoimpresor && this.urlAutoimpresor.valor && this.urlAutoimpresor.valor.value) {
      const urlAutoimpresor = new URL(this.urlAutoimpresor.valor.value);
      let state = $ngRedux.getState();
      urlAutoimpresor.search = new URLSearchParams({
        endpoint: `${config.serverURL}/notas-credito/${facturasPersistidasIds[0]}/data-autoimpreso`,
        token: state.login.accessToken.token
      });
      fetch(urlAutoimpresor)
        .then(function(response) {
          if(!response.ok) {
            ngNotify.set(`Error al llamar a servicio de autoimpresión`, 'warn');
          }
        })
        .catch(function() {
          ngNotify.set(`Error al llamar a servicio de autoimpresión`, 'warn');
        });
    }
  }

  function canImprimirComprobante(data) {
    return true;
  }

  function canEditCondition(data) {
    return false;
  }

  function canRemoveCondition(data) {
    return false;
  }

  function canAnular(data) {
    return data.estado.value === 'Emitida' && AuthorizationService.hasPermission('update_notas_credito');
  }

  function canAplicar(data) {
    return (data.estado.value === 'Emitida') && AuthorizationService.hasPermission('update_notas_credito');
  }

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  this.abrirCaja = abrirCaja.bind(this);

  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de notas de credito']
    };
    this.form();
    const parametroFilter = Filter.path('codigo').eq('url_autoimpresor');

    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));
  };

  function mapStateToThis(state) {
    if (state.currentUser) {
      this.user = state.currentUser.data;
    }

    this.handleStatus(state);
    return { form: state.form, urlAutoimpresor: state.parametros.data.filter((v) => v.codigo === 'url_autoimpresor')[0]  };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }
  }

  function gotoForm() {
    let caja = localStorageService.get('caja');
    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      return;
    } else if (!caja.sesionActual || caja.sesionActual.estado.value !== 'Abierta') {
      this.abrirCaja('facturar');
    } else {
      this.gotoFormNew();
    }
  }


  function abrirCaja(operacion, itemId) {
    let caja = localStorageService.get('caja');

    let self = this;
    this.localModel.payload = {};
    CustomModal.open({
      title: 'Abrir Caja',
      caja: caja,
      templateUrl: abrirTemplate,
      usuario: this.user,
      fecha: moment(new Date()).format('DD/MM/YYYY hh:mm'),
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.abrirCaja({ id: caja.id }, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data.sesionActual.estado.value === 'Abierta') {
            ngNotify.set(self.translations['Abierta Correctamente'], 'success');
            localStorageService.set('caja', { id: data.id, numero: data.numero, nombre: data.nombre, sesionActual: data.sesionActual, puntoEmision: data.puntoEmision });
            if (operacion === 'facturar') {
              self.gotoFormNew();
            } else if (operacion === 'aplicar') {
              self.gotoFormAplicar(itemId);
            } else if (operacion === 'nc') {
              self.gotoFormNotaCredito(itemId);
            }
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  function onRemove(itemId) {
    //this.remove('notas-credito', itemId);
    false;
  }

  function onView(itemId) {
    $state.go('home.notas-credito.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/notas-credito/list/notas-credito.component.js